import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { Router } from '@angular/router';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';
import { EnvService } from '../service/env.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  // isAdmin: boolean = false;
  // isLoggedIn: boolean = false;
  accountCategory: string;
  accountType: string;
  accountStatus: string;
  // isDeveloper: boolean = false;
  // isFinanceAdmin: boolean = false;

  //Search result storage variable
  @ViewChild('searchResult') searchResult:SearchResultsComponent;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;
  @ViewChild('tokenframe') iframe: ElementRef;
  accountId: string;
  
  constructor(public apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService, private router: Router, private searchService: SearchDataService, public env: EnvService) {
  }

   ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.accountStatus = this.apiService.accountDetail.status;
    this.accountId = this.apiService.accountDetail.id;
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });

  }

  private processSearchResult() {
    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.showSearchResult = true;
    }
    else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  onNavSearchClick() {
    this.searchResult.onNavSearchClick();
  }

  isShowKinesisData() {
    if (this.env.ENV == Constants.PRODUCTION)
      return Constants.KINESIS_DATA_ENABLED_FOR_ACCOUNT_PROD.includes(this.accountId);
    else
      return Constants.KINESIS_DATA_ENABLED_FOR_ACCOUNT_STAGE.includes(this.accountId);
  }
}